@if (state$ | async; as state) {
  @if (state.buttonVisible) {
    <button
      class="container"
      (click)="onClick()"
      [attr.aria-label]="'l-support-button-label' | translate"
      [matTooltip]="'l-support-button-label' | translate"
      [style.--support-button-bottom]="state.position.bottom"
      [style.--support-button-right]="state.position.right"
    >
      <div class="an an-question"></div>
    </button>
  }
}
